import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Activity document interface
 */
export interface ActivityDocument extends BaseDocument {
  entityType: string
  entityId: string
  activityType: string
  fieldName: string | null
  description: string | null
  oldValue: string | null
  newValue: string | null
  metadata: string | null
  userId: string
  targetUserId: string | null
  userName: string | null
  userEmail: string | null
}

/**
 * Activity-specific hooks
 */
const hooks = createEntityHooks<ActivityDocument>('activities')

export const useActivities = (filter?: Partial<ActivityDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { activities: data, isLoading, db }
}

export const useActivity = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { activity: data, isLoading }
}

export const useActivityMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createActivity: create,
    updateActivity: update,
    deleteActivity: deleteEntity,
  }
}
